import { createContext } from 'react'
import type { NestPickerGroup } from '../components/NestPicker'

/**
 * **„Einhängen in …“ im Aufgaben-Menü** (#204, Grill 9). Die Liste (`TaskBoard`) stellt die
 * Kandidaten und den Weg bereit; das Menü sitzt fünf Ebenen tiefer in jeder Zeile.
 *
 * Gelesen wird erst beim Öffnen: Der Wert selbst ändert sich nicht mit jeder Auswahl — sonst
 * renderte jedes Menü jeder Zeile bei jedem Klick neu.
 */
export interface NestMenu {
  /**
   * Die offenen Aufgaben der Liste, nach Abschnitt; ausgegraut, was kein Ziel sein kann — auch
   * eine wiederkehrende, wenn sich eine der Gezogenen wiederholt (#205).
   */
  groupsFor(taskId: string, ids?: readonly string[]): NestPickerGroup[]
  /**
   * Hängt die Aufgabe — oder die Auswahl, zu der sie gehört — in `parentId` ein. Mit `ids` genau
   * diese (die **Listen-Werkzeug-Pille** hängt nur die offenen der Auswahl ein, #291).
   */
  nest(taskId: string, parentId: string, ids?: readonly string[]): void
  /** Herausgelöste Aufgaben in der Liste auswählen, sobald sie dort stehen (⇧⌥ in der offenen Karte). */
  selectInList(ids: string[]): void
  /**
   * **Umhängen in …** aus dem Menü einer Unteraufgabe (#205): Wie beim Ziehen klappt das Ziel
   * auf, und die Zeilen sind dort angefasst.
   */
  moveSubtasks(ids: string[], parentId: string): void
}

export const NestMenuContext = createContext<NestMenu | null>(null)
